import { useEffect, useState } from "react";
import useData from "hooks/useData";

export function useComment(id) {
  const [ comment, setComment ] = useState();
  const [ isLoading, setIsLoading ] = useState(id);
  const [ error, setError ] = useState('');
  const { getData } = useData();

  const path = `rest/comment/${ id }`;

  useEffect(
    () => {
      const load = async () => {
        setIsLoading(true);
        let result;
        try {
          result = await getData(path);
        } catch (exception) {
          console.error(exception);
          setError('De reactie kon niet worden opgehaald. Ververs de pagina of probeer het later opnieuw.');
        }
        setComment(result.data);
        setIsLoading(false);
      }
      if (id) {
        load();
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ id, path ]);

  return { comment, isLoading, error };
}

export default useComment;
